module.exports = __webpack_public_path__ + "media/images/pic/groups/small/school-8b6c4bc1f757cfa7402e10eb59e4f2f1.jpeg";